var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBienvenueCurvedLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00212 4.62423C1.00212 4.62423 196.937 26.7597 326.23 31.6293C635.583 43.2804 788.914 -7.66616 1098.49 3.06897C1230.28 7.63916 1439.33 31.6263 1439.33 31.6263",
    stroke: "#FBF0E5",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBienvenueCurvedLine);
export default __webpack_public_path__ + "static/media/bienvenue-curved-line.a1416baf0ad78803c8ceb3d290423f90.svg";
export { ForwardRef as ReactComponent };